module.exports = __webpack_public_path__ + "static/media/edit-pencil-green.60b66022.svg";